import { defineStore } from 'pinia'


export const basicStore = defineStore('basicStore', {
  state: () => ({
    host:"https://api.aleshrakcentre.com",
    //host:"http://localhost:3000",
    section:"اولياء الامور",
    specializations:[
      'لا تخصص',
      "مهارات و منتسوري",
      "وظيفي",
      "سيكو",
      "الرعايه",
      "الحسي",
      "تخاطب",
      "سلوك",
      "علاج طبيعي",
      "اورال",
    ],
    specializations2:[
      "مهارات و منتسوري",
      "وظيفي",
      "سيكو",
      "الرعايه",
      "الحسي",
      "تخاطب",
      "سلوك",
      "علاج طبيعي",
      "اورال",
    ],
    works: [
      "اخصائي",
      "اشراف",
      "سكرتارية",
      "خدمات و معاونة",
      "إداري",
      "استشاري"
    ]
  })
})